// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport } from '@tectonics/prs/validation';

import { validateBankCode } from './bank-code';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, 'cash');
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  if (userInputName === 'selectedBankCode') {
    return onlyWhen('field_argentine_cash_bank_list') && validateBankCode(userInputValue);
  }

  return undefined;
}
